import { createFileRoute } from '@tanstack/react-router';

import Loading from '@/_pages/settings/products-and-services-templates/profile/loading';

export const Route = createFileRoute('/_private/settings/products-and-services-templates/$id')({
  pendingComponent: Loading,
});
